const MARK_VIEWBOX_WIDTH = 204;
const MARK_VIEWBOX_HEIGHT = 107;

type VeeIconProps = {
  className?: string;
  height?: number;
};

export function VeeIcon({ className, height = 10 }: VeeIconProps) {
  return (
    <svg
      aria-hidden={true}
      className={className}
      fill="currentColor"
      height={height}
      viewBox={`32 76 ${MARK_VIEWBOX_WIDTH} ${MARK_VIEWBOX_HEIGHT}`}
      width={(height * MARK_VIEWBOX_WIDTH) / MARK_VIEWBOX_HEIGHT}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M51.1711 76H32V182.632H51.1711V76Z" />
      <path d="M78.9055 76H59.7344V182.632H78.9055V76Z" />
      <path d="M106.655 76H87.4844V182.632H106.655V76Z" />
      <path d="M157.455 76H177.905L135.685 182.632H115.234L157.455 76Z" />
      <path d="M186.47 76H206.921L164.701 182.632H144.25L186.47 76Z" />
      <path d="M215.502 76H235.952L193.732 182.632H173.281L215.502 76Z" />
    </svg>
  );
}
